import axios from 'axios';

// const Login=(data)=>axios.post('/auth/login/orgLogin',data);
const Login=(data)=>axios.post('/auth/govLogin',data);
const loginOut=(data)=>axios.post('/auth/login/logout',data);
const qyjj = (data) => axios.get('/custom/brief/mine', data);
// 登录详情
const getLoginInfo=(data)=>axios.get('/system/user/getInfo',data);

export default {
  Login,
  getLoginInfo,
  loginOut,
  qyjj,
}
